import React from 'react'
const Typography = React.lazy(() => import('@material-ui/core/Typography'));
const Link = React.lazy(() => import('@material-ui/core/Link'));
import {history} from '~/router/history';
import {CATALOG_PRODUCTS, CATALOG_ORDERS, INVOICE_LIST} from '~/router/routes';
import {generatePath} from 'react-router';
import './style.css';

export default class NotFoundPageComponent extends React.Component {

    render() {
        return (
            <div className='not-found'>
                <Typography variant="h3" component="h1" align='center'>Упс! Страница не найдена :(</Typography>
                <Typography variant="h6" component="h2" align='center' gutterBottom>Code 404</Typography>
                <div className='not-found__links'>
                    <Link variant="h6" style={{cursor: 'pointer'}} onClick={() => {history.push(generatePath(CATALOG_PRODUCTS))}}>
                        Товары
                    </Link>
                    <Link variant="h6" style={{cursor: 'pointer'}} onClick={() => {history.push(generatePath(CATALOG_ORDERS))}}>
                        Заказы
                    </Link>
                    <Link variant="h6" style={{cursor: 'pointer'}} onClick={() => {history.push(generatePath(INVOICE_LIST))}}>
                        Биллинг
                    </Link>
                </div>
                <div className="not-found__gears">
                    <div className="gear one">
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                    <div className="gear two">
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                    <div className="gear three">
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                </div>
            </div>
        )
    }
}
